import { render } from "./ProfileAndTubePriceComponent.vue?vue&type=template&id=5b169f57&scoped=true"
import script from "./ProfileAndTubePriceComponent.vue?vue&type=script&lang=js"
export * from "./ProfileAndTubePriceComponent.vue?vue&type=script&lang=js"

import "./ProfileAndTubePriceComponent.vue?vue&type=style&index=0&id=5b169f57&scoped=true&lang=css"

import exportComponent from "D:\\Cotizador Frontend\\dyc_cotizador_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b169f57"]])

export default __exports__